/**
 * Returns exactly 2 uppercase initials for a given name.
 * - Single word: first 2 characters (e.g. "Eduardo" → "ED")
 * - Multiple words: first letter of first word + first letter of last word
 *   (e.g. "João Paulo Silva" → "JS")
 */
export const getInitials = (name?: string | null, fallback = '?'): string => {
  if (!name) return fallback;
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return fallback;
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};
